import {Factory} from './Factory'
import { TabFactory } from './TabFactory'
import Menu from '../EditorComponents/Tabs/Menu'

export class TabsFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('tabs'),
      contentId: this.id('tabs-content'),
      slug: 'editor-tabs',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      sections: (new TabFactory).create(),
      name: 'Tabs',
    }
  }

  properties() {
    return {
      contentStyles: [
        {key: 'content-background', component: 'BackgroundProperty', styles: 'elementContentStyles', class: 'contentClasses', only:['color']},
        {key: 'content-border', component: 'BorderProperty', styles: 'elementContentStyles', class: 'contentClasses'},
        {key: 'content-shadow', component: 'ShadowProperty', styles: 'elementContentStyles', class: 'contentClasses'},
      ],
      styles: [
        {key: 'tabs-margin', component: 'MarginProperty', class:'containerClasses'},
      ],
      tabsStyles: [
        {key: 'tabs-background', component: 'BackgroundProperty',styles: 'elementTabsStyles', class: 'tabsClasses', only:['color']},
        {key: 'tabs-border', component: 'BorderProperty', styles: 'elementTabsStyles', class: 'tabsClasses'},
        {key: 'tabs-padding', component: 'PaddingProperty', class: 'tabsClasses'},
        {key: 'tabs-direction', component: 'FlexDirectionProperty', class: 'tabsClasses'},
        // {key: 'tabs-justify', component: 'FlexJustifyProperty', class: 'tabsClasses'},
        // {key: 'tabs-align', component: 'FlexAlignProperty', class: 'tabsClasses'}
      ],
      activeStyles: [
        {key: 'active-background', component: 'BackgroundProperty', styles: 'activeStyles', class: 'activeClasses', only:['color']},
        {key: 'active-text-color', component:'TextColorProperty', styles: 'activeStyles'},
        {key: 'active-border', component: 'BorderProperty', styles: 'activeStyles', class: 'activeClasses'},
        {key: 'active-font-size', component: 'FontSizeProperty', class: 'activeClasses'},
        {key: 'active-padding', component:'PaddingProperty', class: 'activeClasses'},
      ],
      inactiveStyles: [
        {key: 'inactive-background', component: 'BackgroundProperty', styles: 'inactiveStyles', class: 'inactiveClasses', only:['color']},
        {key: 'inactive-text-color', component: 'TextColorProperty', styles: 'inactiveStyles'},
        {key: 'inactive-border', component: 'BorderProperty', styles: 'inactiveStyles', class: 'inactiveClasses'},
        {key: 'inactive-font-size', component: 'FontSizeProperty', styles: 'inactiveStyles', class: 'inactiveClasses'},
        {key: 'inactive-padding', component: 'PaddingProperty', styles: 'inactiveStyles', class: 'inactiveClasses'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
			menu: Menu
    }
  }
}